package com.loyola.acessoescola.services.quintadb

//private const val API_HOST = "http://10.0.2.2:8000" //local host android
//private const val API_HOST = "http://127.0.0.1:8000" //localhostweb
//private const val API_HOST = "http://10.12.1.81:8000" //servidor interno
//private const val API_HOST = "https://loyola-acesso-escola.salmonbeach-d36e301f.brazilsouth.azurecontainerapps.io"// servidor publico


const val API_HOST = "https://loyola-acesso-escola.salmonbeach-d36e301f.brazilsouth.azurecontainerapps.io"// servidor publico
enum class EndPoints(val endPoint: String) {
    RECORD(endPoint = "$API_HOST/record"),
    RECORDS(endPoint="$API_HOST/records"),
    CREATE_RECORD(endPoint = "$API_HOST/create_record"),
    UPLOAD_FILE(endPoint = "$API_HOST/upload_file"),
    UPDATE_RECORD(endPoint = "$API_HOST/update_record"),
    DELETE_RECORD(endPoint = "$API_HOST/delete_record"),
    PROXY_IMAGE(endPoint = "$API_HOST/proxy-image")
}